import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const NotificationRenderer = (props) => {
    const renderViaPortal = !!props.domNode && !!props.domNodeId;

    if (!renderViaPortal) {
        return props.children;
    }

    let renderNode;

    if (props.domNode) {
        renderNode = props.domNode;
    }

    if (props.domNodeId) {
        renderNode = document.getElementById(props.domNode);
    }

    return ReactDOM.createPortal(props.children, renderNode);
};

NotificationRenderer.propTypes = {
    children: PropTypes.node.isRequired,
    domNode: PropTypes.node,
    domNodeId: PropTypes.string,
};

export default NotificationRenderer;
